import { Card, CardBody, Spinner } from '@chakra-ui/react'
import Empty from '../../../components/Empty'
import PageHeader from '../../../components/PageHeader'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'
import tableStore from '../../../lib/store/affiliate_transaction_table'
import { IDataResponse, serialize } from '../../../network/request'
import { useNavigate, useParams } from 'react-router-dom'
import AffiliateTransactionTable from './AffiliateTransactionTable'
import { Transaction } from '../../../network/services/transaction'
import AffiliateTransactionService from '../../../network/services/affiliateTransaction'

const AffiliateTransactionsPage = () => {
  const navigate = useNavigate()

  return (
    <PageHeader title='報酬履歴'>
      <Card>
        <CardBody>
          <AffiliateTransactionTableWrapper />
        </CardBody>
      </Card>
    </PageHeader>
  )
}

const AffiliateTransactionTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR<IDataResponse<Transaction>>(
    serialize(AffiliateTransactionService.getAll, {
      page: state.currentPage,
      limit: state.pageSize,
      sort: state.sort ?? 'created_at:desc',
      refresh: state.refresh,
      ...state.filters,
    })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spinner />
  }

  const { total } = AffiliateTransactionService.toPaginate(response)

  return (
    <>
      <AffiliateTransactionTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <AffiliateTransactionTable
            total={total}
            overridePage={state.currentPage + 1}
          />
        </div>
      )}
    </>
  )
}

export default AffiliateTransactionsPage
